module.exports = __webpack_public_path__ + "img/icon-header-arrow.434f4121.svg";